import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthorizationService } from 'src/app/services/authorization.service';
import { RequestService } from 'src/app/services/request.service';
import { OtherService } from 'src/app/services/other.service';
import { forkJoin, tap } from 'rxjs';

import { Router } from '@angular/router';
@Component({
  selector: 'app-tips-management',
  templateUrl: './tips-management.component.html',
  styleUrls: ['./tips-management.component.scss']
})


export class TipsManagementComponent implements OnInit {

  superAdmin: boolean = false;
  superUser: boolean = false;
  subAdmin: boolean = false;
  consultantInfo: any | undefined = '';
  farmerInfo: any | undefined = '';

  constructor(
    public translate: TranslateService,
    private authorizationService: AuthorizationService,
    private req: RequestService<any>,
    private questionsService: OtherService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.getUsersRoles();
    this.getUsersInfo();
  }

  getUsersInfo() {
    forkJoin({
      profile: this.req.getUserProfile(),
      farmer: this.req.getFarmer(),
    }).subscribe({
      next: ({ profile, farmer }) => {
        this.consultantInfo = profile
        this.farmerInfo = farmer
      },
      error: (err) => {
        console.error("Error fetching data: ", err);
      }
    });
  }

  getIconClass(iconType: string): string {
    const iconClasses = [
      'pie-icon',
      'user-icon',
      'upload-icon',
      'bug-icon',
      'weather-icon',
      'contact-icon',
      'leaf-icon',
      'wind-icon',
      'metal-icon',
      'light-icon',
      'stats-icon'
    ];

    return iconClasses.includes(iconType) ? iconType : 'user-icon';
  }

  openIrrigationPage() {
    window.open('https://irrigation.staging.wi-sense-water.eu/pages/irrigation', '_blank');
}

  farmerUsageAll() {
    this.questionsService.setSourceType('all');
    this.req.getQuestions().subscribe((res: any) => {
      this.questionsService.setQuestionsAll(res);
      this.router.navigate(['/tips/questions']);
    });
    this.req.getQuestionsStatistics().subscribe(res => {
      this.questionsService.setStatisticsAll(res);
    });
  }

  farmerUsage() {
    this.questionsService.setSourceType('farmer');
    this.req.getQuestionsFarmer().subscribe(res => {
      this.questionsService.setQuestions(res);
      this.router.navigate(['/tips/questions']);
    });
    this.req.getQuestionsStatisticsFarmer().subscribe(res => {
      this.questionsService.setStatistics(res);
    });
  }

  getUsersRoles() {
    this.authorizationService.admin$.subscribe(isAdmin => {
      this.superAdmin = isAdmin
    });

    this.authorizationService.superuser$.subscribe(isSuperuser => {
      this.superUser = isSuperuser
    });

    this.authorizationService.subadmin$.subscribe(isSubadmin => {
      this.subAdmin = isSubadmin
    });
  }


}
